import type {
  AuthenticatedUser,
  AuthenticatedUserDto,
} from '@src/features/users';
import { createContext } from 'react';
import type {
  AuthCredentials,
  AuthData,
  JwtCredentials,
  Token2FAEnrollment,
} from './providers';
import type { TokenPair } from '../lib/tokenPair';

export type AuthenticationContextValue = {
  login: (username: string, password: string) => Promise<AuthCredentials>;
  logout: () => Promise<AuthCredentials>;
  verifyToken: () => Promise<AuthCredentials>;
  verifyTwoFactor: (
    challengeToken: string | null,
    otpCode: string,
  ) => Promise<JwtCredentials | null>;
  startTwoFactorEnrollment: (token: string) => Promise<Token2FAEnrollment>;
  refreshToken: () => Promise<JwtCredentials>;
  exchangeImpersonationCode: (code: string) => Promise<JwtCredentials>;
  authenticate: (data: AuthData) => AuthCredentials;
  replaceTokens: (tokens: TokenPair) => JwtCredentials;
  updateUser: (
    user: Partial<AuthenticatedUserDto>,
  ) => JwtCredentials | null;
  unauthenticate: () => AuthCredentials;
  credentials: JwtCredentials | null;
  isAuthenticated: boolean;
  user: AuthenticatedUser | null;
};

const AuthenticationContext = createContext<AuthenticationContextValue | null>(
  null,
);

export default AuthenticationContext;
